import _ from 'lodash';

Object.assign(window, { _, lodash: _ });
